import map from "lodash/map";
import { CheerzApiPromo } from "@Types/api/promos";
import PromosContent from "@Types/promos";

export function convertFromApiToPromosContent(jsonContent: CheerzApiPromo[]): PromosContent[] {
  return map(jsonContent, (promo) => {
    return {
      code: promo.content,
      description: promo.excerpt,
      priority: promo.priority,
      title: promo.title,
    };
  });
}
